import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=72a83e54&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=72a83e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a83e54",
  null
  
)

export default component.exports